import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _5328349e = () => import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */).then(m => m.default || m)
const _045fc7af = () => import('../src/pages/_lang/index.vue' /* webpackChunkName: "pages/_lang/index" */).then(m => m.default || m)
const _1a9e083c = () => import('../src/pages/_lang/html/about-us/index.vue' /* webpackChunkName: "pages/_lang/html/about-us/index" */).then(m => m.default || m)
const _4f37681f = () => import('../src/pages/_lang/html/ceo/index.vue' /* webpackChunkName: "pages/_lang/html/ceo/index" */).then(m => m.default || m)
const _2f43e822 = () => import('../src/pages/_lang/html/contact-us/index.vue' /* webpackChunkName: "pages/_lang/html/contact-us/index" */).then(m => m.default || m)
const _d408afd2 = () => import('../src/pages/_lang/html/news/index.vue' /* webpackChunkName: "pages/_lang/html/news/index" */).then(m => m.default || m)
const _97cede30 = () => import('../src/pages/_lang/html/products/index.vue' /* webpackChunkName: "pages/_lang/html/products/index" */).then(m => m.default || m)
const _11e2feb4 = () => import('../src/pages/_lang/html/news/all.vue' /* webpackChunkName: "pages/_lang/html/news/all" */).then(m => m.default || m)
const _69582a07 = () => import('../src/pages/_lang/html/news/detail/_id.vue' /* webpackChunkName: "pages/_lang/html/news/detail/_id" */).then(m => m.default || m)



if (process.client) {
  window.history.scrollRestoration = 'manual'
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected
  if (to.matched.length < 2) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some((r) => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}


export function createRouter () {
  return new Router({
    mode: 'history',
    base: '',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/",
			component: _5328349e,
			name: "index"
		},
		{
			path: "/:lang",
			component: _045fc7af,
			name: "lang"
		},
		{
			path: "/:lang/html/about-us",
			component: _1a9e083c,
			name: "lang-html-about-us"
		},
		{
			path: "/:lang/html/ceo",
			component: _4f37681f,
			name: "lang-html-ceo"
		},
		{
			path: "/:lang/html/contact-us",
			component: _2f43e822,
			name: "lang-html-contact-us"
		},
		{
			path: "/:lang/html/news",
			component: _d408afd2,
			name: "lang-html-news"
		},
		{
			path: "/:lang/html/products",
			component: _97cede30,
			name: "lang-html-products"
		},
		{
			path: "/:lang/html/news/all",
			component: _11e2feb4,
			name: "lang-html-news-all"
		},
		{
			path: "/:lang/html/news/detail/:id?",
			component: _69582a07,
			name: "lang-html-news-detail-id"
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js